//extracted by mini-css-extract-plugin
export default {"sparkLogo":"styles_sparkLogo__gyw2g","messageBox":"styles_messageBox__QlFOB","messageBody":"styles_messageBody__MOsMK","buttonContainer":"styles_buttonContainer__hgt1g"};;